import React from "react";

const ActivityFeedback = ({ analytics }) => {
  // 1. شرط الإخفاء
  if (!analytics || !analytics.totalReviews || analytics.totalReviews === 0) {
    return null;
  }

  const { overallRating, totalReviews, starDistribution, reviewsList } = analytics;

  // --- Helpers ---
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <span
        key={index}
        style={{ color: index < Math.round(rating) ? "#ffc107" : "#e4e5e9", fontSize: "1rem" }}
      >
        ★
      </span>
    ));
  };

  const getInitials = (name) => {
    if (!name) return "U";
    const parts = name.split(" ");
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };

  const getAvatarColor = (name) => {
    const colors = ["#0d6efd", "#6610f2", "#6f42c1", "#d63384", "#dc3545", "#fd7e14", "#198754", "#20c997", "#0dcaf0"];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <>
      <style>
        {`
          /* === Base Styles === */
          .custom-scrollbar::-webkit-scrollbar { width: 5px; }
          .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
          .custom-scrollbar::-webkit-scrollbar-thumb { background-color: #dee2e6; border-radius: 20px; }
          
          .avatar-circle {
            width: 42px; height: 42px; border-radius: 50%;
            display: flex; align-items: center; justify-content: center;
            color: white; font-weight: 700; font-size: 0.9rem; flex-shrink: 0;
          }
          
          .rating-number { font-size: 3.5rem; line-height: 1; letter-spacing: -2px; }
          
          /* === Desktop Styles (Large Screens) === */
          @media (min-width: 992px) {
            .stats-column { border-right: 1px solid #edf2f4; padding-right: 2rem; }
            .card-body-custom { padding: 3rem; }
          }

          /* === Mobile Styles (Small Screens) === */
          @media (max-width: 991px) {
            .stats-column { 
              border-bottom: 1px solid #edf2f4; 
              padding-bottom: 2rem; 
              margin-bottom: 2rem;
            }
            .rating-number { font-size: 2.8rem; } /* تصغير الرقم ع الموبايل */
            .card-body-custom { padding: 1.5rem; } /* تقليل الحواف ع الموبايل */
            
            /* تحسين السكرول للموبايل */
            .reviews-list-wrapper {
              -webkit-overflow-scrolling: touch; /* سحر السلاسة ع الآيفون */
            }
          }
        `}
      </style>

      <div className="card shadow-sm border-0 rounded-4 mt-4 mb-5 overflow-hidden">
        {/* Header */}
        <div className="card-header bg-white border-bottom border-light py-3 px-lg-4 px-3">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
              Feedback Analysis
              {/* Badge يظهر بس ع الديسكتوب */}
              <span className="d-none d-sm-inline bg-light text-dark border rounded-pill fw-normal ms-2">
                {totalReviews} Reviews
              </span>
            </h5>
            {/* Badge صغير للموبايل */}
            <span className="d-sm-none bg-light text-dark border rounded-pill">
              {totalReviews}
            </span>
          </div>
        </div>

        <div className="card-body card-body-custom">
          <div className="row g-0">
            
            {/* === Left Column: Stats === */}
            <div className="col-lg-4 stats-column">
              <div className="text-center">
                <div className="rating-number fw-bold text-dark mb-1">{overallRating}</div>
                <div className="mb-2">{renderStars(overallRating)}</div>
                <p className="text-muted small mb-4">Overall Activity Rating</p>
              </div>

              {/* Progress Bars */}
              <div className="d-flex flex-column gap-2 px-lg-0 px-2">
                {starDistribution.map((item) => (
                  <div key={item.star} className="d-flex align-items-center gap-2" style={{fontSize: '0.85rem'}}>
                    <span className="fw-bold text-secondary text-center" style={{ width: "12px" }}>{item.star}</span>
                    <span className="text-warning">★</span>
                    <div className="progress flex-grow-1 shadow-none" style={{ height: "6px", backgroundColor: "#f3f4f6" }}>
                      <div
                        className="progress-bar bg-warning"
                        role="progressbar"
                        style={{ width: `${item.percentage}%`, borderRadius: "10px" }}
                      ></div>
                    </div>
                    <span className="text-muted text-end" style={{ width: "30px", fontSize: "0.8rem" }}>
                      {item.percentage}%
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* === Right Column: Reviews List === */}
            <div className="col-lg-8 ps-lg-5">
              <h6 className="fw-bold mb-4 text-dark text-uppercase small letter-spacing-1">
                Latest Comments
              </h6>
              
              {reviewsList.length === 0 ? (
                <div className="text-center text-muted py-4 bg-light rounded-3">
                  <small>No written reviews available yet.</small>
                </div>
              ) : (
                <div 
                  className="custom-scrollbar reviews-list-wrapper pe-2" 
                  style={{ maxHeight: "400px", overflowY: "auto" }}
                >
                  {reviewsList.map((review) => (
                    <div key={review._id} className="d-flex gap-3 mb-4">
                      
                      {/* Avatar */}
                      <div 
                        className="avatar-circle shadow-sm" 
                        style={{ backgroundColor: getAvatarColor(review.studentName) }}
                      >
                        {getInitials(review.studentName)}
                      </div>

                      {/* Content */}
                      <div className="flex-grow-1 bg-light rounded-3 p-3 position-relative">
                        {/* السهم الصغير اللي بيشاور عالصورة (Optional Design Touch) */}
                        <div style={{
                          position: "absolute", top: "15px", left: "-6px", 
                          width: "12px", height: "12px", background: "#f8f9fa", 
                          transform: "rotate(45deg)"
                        }}></div>

                        <div className="d-flex justify-content-between align-items-start mb-2 position-relative">
                          <div>
                            <h6 className="fw-bold text-dark mb-0" style={{fontSize: '0.95rem'}}>{review.studentName}</h6>
                            <small className="text-muted" style={{ fontSize: "0.75rem" }}>{review.date}</small>
                          </div>
                          <div>{renderStars(review.rating)}</div>
                        </div>

                        <p className="text-secondary mb-0 position-relative" style={{ fontSize: "0.9rem", lineHeight: "1.5" }}>
                          {review.comment || <em className="text-muted opacity-50">No comment provided.</em>}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivityFeedback;